import classnames from 'classnames/bind'
import React from 'react'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalGridPreset } from '~/@types/grid-preset'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { LinkProps } from '@unlikelystudio/react-abstract-components'

import PopIn from '~/components/Abstracts/PopIn'
import { RichTextBlock } from '~/components/Abstracts/RichText'
import ContactPopin from '~/components/Popins/ContactPopin'
import { CloseIcon } from '~/components/UI/Icons'
import RichText from '~/components/UI/RichText'
import SquaredCta from '~/components/UI/SquaredCta'

import { usePopIn } from '~/providers/PopInProvider'
import { useStyle } from '~/providers/StyleProvider'

import { isRTFilled } from '~/utils/check-empty-string'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type PanelContactProps = {
  className?: string
  title?: RichTextBlock
  subtitle?: RichTextBlock
  cta?: LinkProps
}

function PanelContact({ className, title, subtitle, cta }: PanelContactProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })
  const titleStyle = useStyle({ textPreset: GlobalTextPreset.Title40SangBleu })
  const subtitleStyle = useStyle({
    textPreset: GlobalTextPreset.Text12SangBleu,
    textStyling: GlobalTextStyling.Italic,
  })

  const { add: addPopin } = usePopIn()

  const showContactPopin = () => {
    addPopin(
      <PopIn
        className={cx(css.popin)}
        isCloseButton={true}
        closeButton={<CloseIcon className={css.alertStockIconClose} />}>
        <ContactPopin className={cx(css.contactPopin)} />
      </PopIn>,
    )
  }

  const hasContent = isRTFilled(title) || cta || isRTFilled(subtitle)

  return hasContent ? (
    <div className={cx(css.PanelContact, className)}>
      <div className={gridStyle}>
        {title && (
          <RichText render={title} className={cx(titleStyle, css.title)} />
        )}
        {subtitle && (
          <RichText
            render={subtitle}
            className={cx(subtitleStyle, css.subtitle)}
          />
        )}
        {cta && (
          <SquaredCta
            theme={GlobalThemeColors.White}
            withBackground
            onClick={showContactPopin}
            className={css.cta}
            {...cta}
            href={null}
          />
        )}
      </div>
    </div>
  ) : null
}

PanelContact.defaultProps = {}

export default PanelContact
